import {
  GraphQLObjectType,
  GraphQLFloat,
  GraphQLNonNull,
  GraphQLID,
  GraphQLString,
  GraphQLList
} from 'graphql';
import { toGlobalId } from 'graphql-relay';

import CardQuestionOptionType from './cardQuestionOptionType.gql';
import ReviewsGivenType from './reviewsGiven.gql';
import ReviewsReceivedType from './reviewsReceived.gql';

const peerQuestionForReviewType = new GraphQLObjectType({
  name: 'PeerQuestionForReview',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: (root) => {
        const offerId = root._id.toString();
        const userId = root.userId.toString();
        return toGlobalId('PeerQuestionForReview', `${offerId}-${userId}`);
      }
    },
    pid: {
      type: GraphQLString,
      resolve: (item) => {
        const offerId = item._id;
        return offerId;
      }
    },
    question: {
      type: GraphQLString,
      resolve: (root) => {
        const question = root.content.question;
        if (!question) {
          return null;
        }
        return question.questionText;
      }
    },
    rType: {
      type: GraphQLString,
      resolve: (root) => {
        const question = root.content.question;
        if (!question) {
          return null;
        }
        return question.responseType[0];
      }
    },
    maxScore: {
      type: GraphQLFloat,
      resolve: (root) => {
        const maxScore = root.maxScore || 0.0;
        return maxScore;
      }
    },
    options: {
      type: new GraphQLList(CardQuestionOptionType),
      resolve: root => root.content.question.options || []
    },
    reviewsGiven: {
      type: new GraphQLList(ReviewsGivenType),
      resolve: item => item.reviewsGiven.slice()
    },
    reviewsReceived: {
      type: new GraphQLList(ReviewsReceivedType),
      resolve: item => item.reviewsReceived.slice()
    }
  })
});

window[peerQuestionForReviewType.name + 'GQLType'] = peerQuestionForReviewType;

export default peerQuestionForReviewType;
